import React from 'react'
import { OutletPresenter } from 'shared/presenters/OutletPresenter'
import useTranslation from 'next-translate/useTranslation'
import { H4, Text } from 'library/atoms/Typography'
import { BackBreadcrumb } from 'library/molecules/Breadcrumb'
import Layout from 'library/atoms/Layout'
import Head from 'next/head'
import Header from 'library/molecules/Header'

export interface CancellationPolicyProps {
  outlet: OutletPresenter
  goToDetails: () => void
  view?: string
}

const CancellationPolicy = ({
  outlet,
  goToDetails
}: CancellationPolicyProps) => {
  const { t } = useTranslation('outlets')
  const cancellationPolicy = outlet.cancellationPolicy()

  return (
    <>
      <Head>
        <title>{t('cancellation-policy-title')}</title>
      </Head>

      <Layout>
        <Header />
        <BackBreadcrumb title={t('common:back')} onClick={goToDetails} />
        <main>
          <H4>{cancellationPolicy.tagline}</H4>
          <Text
            as="div"
            color="secondary"
            dangerouslySetInnerHTML={{
              __html: cancellationPolicy.html
            }}
          />
        </main>
      </Layout>
    </>
  )
}

export default CancellationPolicy
